import React, { useState } from "react";
import Modal from "../../../components/Modal";
import CustomInput from "../../../components/CustomInput";
import DatePicker from "../../../components/DatePicker";
import { formatDateInput } from "../../../../../utils/DateFormat";
import CustomSelect from "../../../components/CustomSelect";

const PopupUpdate = ({
  isOpen,
  onClose,
  data,
  onSave,
  staffOptions = [],
  onLoadStaff,
}) => {
  const [updateData, setUpdateData] = useState(() => ({
    ...data,
    createdDate: data.createdDate ? formatDateInput(data.createdDate) : "",
    dateActive: data.dateActive ? formatDateInput(data.dateActive) : "",
    issueDate: data.issueDate ? formatDateInput(data.issueDate) : "",
    expiryDate: data.expiryDate ? formatDateInput(data.expiryDate) : "",
    assignedStaff: data.assignedStaff || null,
    supervisors: (data.supervisors || []).map((sup) => ({
      value: sup._id || sup.value || sup.id || sup,
      label: sup.fullName || sup.label || sup.name || "Không có tên",
    })),
  }));
  const [errors, setErrors] = useState({ soDon: "", soBang: "" });
  const [openPicker, setOpenPicker] = useState(null);
  const [hasLoadedStaff, setHasLoadedStaff] = useState(false);

  const parseDateToYYYYMMDD = (completionDate) => {
    const [day, month, year] = completionDate.split("-");
    return `${day}/${month}/${year}`;
  };

  const handleDatePickerToggle = (picker) => {
    setOpenPicker((prev) => (prev === picker ? null : picker));
  };

  const handleInputChange = (key, value) => {
    setUpdateData((prev) => ({ ...prev, [key]: value }));
    setErrors((prev) => ({ ...prev, [key]: "" }));
  };

  const handleStaffDropdownOpen = () => {
    if (!hasLoadedStaff && onLoadStaff) {
      onLoadStaff();
      setHasLoadedStaff(true);
    }
  };

  const handleSave = () => {
    const formData = {
      profileCode: updateData.soDon,
      numberOfCertificates: updateData.soBang,
      status: updateData.status,
      assignedStaff: updateData.assignedStaff?.value || null,
      supervisors: updateData?.supervisors?.map((s) => s?.value) || [],
    };

    if (updateData.createdDate !== "") {
      formData.createdDate = parseDateToYYYYMMDD(updateData.createdDate);
    }
    if (updateData.dateActive !== "") {
      formData.dateActive = parseDateToYYYYMMDD(updateData.dateActive);
    }
    if (updateData.issueDate !== "") {
      formData.issueDate = parseDateToYYYYMMDD(updateData.issueDate);
    }
    if (updateData.expiryDate !== "") {
      formData.expiryDate = parseDateToYYYYMMDD(updateData.expiryDate);
    }

    onSave(formData);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Chỉnh sửa thông tin hồ sơ"
      maxWidth="1200px"
      primaryButtonText="Lưu lại"
      primaryButtonOnClick={handleSave}
      cancelButtonText="Hủy"
    >
      <div className="px-6 py-4 space-y-4">
        <div className="grid grid-cols-2 gap-4">
          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium text-gray-700">Số đơn:</label>
            <CustomInput
              value={updateData.soDon}
              placeholder="Nhập số đơn"
              onChange={(value) => handleInputChange("soDon", value)}
              error={errors.soDon}
            />
          </div>
          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium text-gray-700">
              Số bằng:
            </label>
            <CustomInput
              value={updateData.soBang}
              placeholder="Nhập số bằng"
              onChange={(value) => handleInputChange("soBang", value)}
              error={errors.soBang}
            />
          </div>
        </div>

        <div className="grid grid-cols-4 gap-4">
          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium text-gray-700">
              Ngày nộp đơn:
            </label>
            <DatePicker
              placeholder="Ngày nộp đơn"
              initValue={updateData.createdDate}
              onChange={(value) => handleInputChange("createdDate", value)}
              height={"52px"}
              isCalendarOpen={openPicker === "createdDate"}
              onToggle={() => handleDatePickerToggle("createdDate")}
            />
          </div>
          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium text-gray-700">
              Ngày công bố:
            </label>
            <DatePicker
              placeholder="Ngày công bố"
              initValue={updateData.dateActive}
              onChange={(value) => handleInputChange("dateActive", value)}
              height={"52px"}
              isCalendarOpen={openPicker === "dateActive"}
              onToggle={() => handleDatePickerToggle("dateActive")}
            />
          </div>
          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium text-gray-700">
              Ngày cấp bằng:
            </label>
            <DatePicker
              placeholder="Ngày cấp bằng"
              initValue={updateData.issueDate}
              onChange={(value) => handleInputChange("issueDate", value)}
              height={"52px"}
              isCalendarOpen={openPicker === "issueDate"}
              onToggle={() => handleDatePickerToggle("issueDate")}
            />
          </div>
          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium text-gray-700">
              Ngày hết hạn:
            </label>
            <DatePicker
              placeholder="Ngày hết hạn"
              initValue={updateData.expiryDate}
              onChange={(value) => handleInputChange("expiryDate", value)}
              height={"52px"}
              isCalendarOpen={openPicker === "expiryDate"}
              onToggle={() => handleDatePickerToggle("expiryDate")}
            />
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium text-gray-700">
              Trạng thái:
            </label>
            <CustomSelect
              options={[
                { value: "Chờ duyệt", label: "Chờ duyệt" },
                { value: "Đang triển khai", label: "Đang triển khai" },
                { value: "Tạm ngưng", label: "Tạm ngưng" },
                { value: "Đã hoàn thành", label: "Đã hoàn thành" },
              ]}
              placeholder="Trạng thái"
              value={updateData.status}
              onChange={(selected) => handleInputChange("status", selected)}
              height={"52px"}
              width={"100%"}
              className="bg-white"
              required
            />
          </div>
          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium text-gray-700">
              Người phụ trách:
            </label>
            <CustomSelect
              options={staffOptions}
              placeholder="Chọn người phụ trách"
              value={updateData.assignedStaff}
              onChange={(selected) =>
                handleInputChange("assignedStaff", selected)
              }
              onDropdownOpen={handleStaffDropdownOpen}
              height={"52px"}
              width={"100%"}
              className="bg-white"
            />
          </div>
          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium text-gray-700">
              Giám sát viên:
            </label>
            <CustomSelect
              options={staffOptions}
              placeholder="Chọn giám sát viên"
              value={updateData.supervisors}
              onChange={(selected) =>
                handleInputChange("supervisors", selected)
              }
              onDropdownOpen={handleStaffDropdownOpen}
              isMulti={true}
              height={"52px"}
              width={"100%"}
              className="bg-white"
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default PopupUpdate;
